var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_3222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11276 30.7963C11.4987 21.1189 18.2894 11.7213 25.3814 2.53856C25.9261 1.82994 24.8287 1.51536 24.3278 1.51084C23.4364 1.50618 22.5075 1.944 21.9618 2.63266C14.7458 11.7416 7.98867 21.2076 1.58326 30.896C1.0811 31.6525 2.09761 31.9512 2.6684 31.9522C3.51933 31.9489 4.62956 31.5318 5.11276 30.7963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6629 36.2168C19.6791 33.2887 23.6953 30.3606 27.7011 27.423C28.1742 27.0784 28.7373 26.3388 27.9484 25.9885C27.1596 25.6382 26.0168 26.0068 25.3791 26.4598C21.3423 29.379 17.3156 32.2976 13.2794 35.2268C12.7968 35.5818 12.2148 36.3424 13.0241 36.7017C13.8334 37.0609 15.0061 36.6908 15.6529 36.2173L15.6629 36.2168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8384 45.511C35.2652 41.8667 44.703 38.2419 54.1283 34.5676C54.649 34.3709 55.8939 33.8469 55.6445 33.0786C55.4071 32.3497 54.0266 32.5702 53.5453 32.7549C44.107 36.3698 34.6802 40.0141 25.2434 43.6589C24.7133 43.8661 23.4383 44.3917 23.6988 45.1794C23.9367 45.9183 25.3472 45.6962 25.8479 45.5005L25.8384 45.511Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_3222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.05,
    height: 44.15,
    fill: "white",
    transform: "translate(0 2.75) rotate(-2.91613)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.10c659577e6d357a0def94705df3682e.svg";
export { ForwardRef as ReactComponent };